import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { DropdownAsyncComponent } from './dropdown-async/dropdown-async.component';
import { InputBoxModule } from '../input-box/input-box.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import {
  DxLoadIndicatorModule,
  DxPopoverModule,
  DxSelectBoxModule,
  DxTextBoxModule,
  DxTagBoxModule,
  DxTemplateModule,
  DxValidatorModule,
  DxTreeViewModule,
  DxDropDownBoxModule,
  DxDataGridModule,
} from 'devextreme-angular';
import { SelectBoxComponent } from './select-box/select-box.component';
import { TagDropdownComponent } from './tag-dropdown/tag-dropdown.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { GridDropdownComponent } from './grid-dropdown/grid-dropdown.component';
import { AtlasAddressDropdownComponent } from './atlas-address-dropdown/atlas-address-dropdown.component';
import { DropDownGridComponent } from '../drop-down-grid/drop-down-grid.component';

@NgModule({
  declarations: [
    MultiSelectComponent,
    DropdownComponent,
    DropdownAsyncComponent,
    SelectBoxComponent,
    TagDropdownComponent,
    GridDropdownComponent,
    AtlasAddressDropdownComponent,
    DropDownGridComponent,
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatRippleModule,
    InputBoxModule,
    TranslateModule,
    MatAutocompleteModule,
    MatInputModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxTagBoxModule,
    DxLoadIndicatorModule,
    DxValidatorModule,
    DxPopoverModule,
    DxTemplateModule,
    DxTreeViewModule,
    DxDropDownBoxModule,
    DxDataGridModule,
    MatProgressBarModule,
  ],
  exports: [
    MultiSelectComponent,
    DropdownComponent,
    DropdownAsyncComponent,
    SelectBoxComponent,
    TagDropdownComponent,
    GridDropdownComponent,
    AtlasAddressDropdownComponent,
    DropDownGridComponent
  ],
})
export class DropdownsModule {}
